/*
<a href="@Context.Request.Path?p=2" class="c-load-more"
    data-container="#@loadMoreGuid"
    data-total="@Model.Total"
    data-response-item=".c-book-block-list__col"
    data-request-handler="Bookshelf"
    data-params='{"foo":"bar"}'
    data-action="replace"
>
*/

const init = () => {

    var $loadMores = $('.c-load-more');
    if ($loadMores.length < 1) return;

    // disable on page load - added for /events
    function checkLoadMoreState() {
        _.each($loadMores, function(el) {
            var $loadMore = $(el);
            var total = parseInt($loadMore.attr('data-total') || 0, 10);
            var $container = $($loadMore.data('container'));
            var responseItem = $loadMore.data('response-item');
            var noDisplayingItems = $container.find(responseItem).length;
            if (noDisplayingItems >= total) {
                $loadMore.addClass('is-disabled');
            }
        });
    }
    
    // Run immediately when DOM is ready
    checkLoadMoreState();

    $loadMores.click(function(e) {
        e.preventDefault();
        var $loadMore = $(this);
        var container = $loadMore.data('container');
        var responseItem = $loadMore.data('response-item');
        var requestHandler = $loadMore.data('request-handler');
        var total = parseInt($loadMore.attr('data-total') || 0, 10);
        var $container = $(container);
        if ($loadMore.hasClass('is-disabled')) return;
        $loadMore.addClass('is-loading');

        var href = $loadMore.attr('href').split('?p=')[0];

        // 1 - 99
        var nextPage = $loadMore.attr('data-next-page');
        if (!nextPage) nextPage = 2;
        
        var url = href + '?p=' + nextPage + '&handler=' + requestHandler;

        var params = $loadMore.attr('data-params');
        var data = params ? JSON.parse(params) : {};

        var jqXhr = $.get(url, data)
            .done(function(data, textStatus, jqXhr) {

                var $newItems = $('<div/>')
                    .append(data)
                    .find(responseItem);

                nextPage++;
                $loadMore.attr('data-next-page', nextPage);

                $loadMore.removeClass('is-loading');
                var action = $loadMore.attr('data-action') || 'append';
                
                if ($newItems.length < 1) {
                    $loadMore.addClass('is-disabled');

                    // no events hack
                    if (responseItem === '.c-events-list__col' && action === 'replace') {
                        $container.empty();
                        $container.append('<p class="c-events__no-results">No events found.</p>');
                        $container.parents('.c-events-list').removeClass('is-loading')
                    }

                } else {

                    if (action === 'replace') {
                        $container.empty();
                    }


                    $container.append($newItems);

                    PubSub.publish('load-more:success', container);

                    // check total
                    if (total) {
                        var noDisplayingItems = $container.find(responseItem).length;
                        if (noDisplayingItems >= total) {
                            $loadMore.addClass('is-disabled');
                        }
                    }

                    // Trigger lazy loading migration for new content
                    setTimeout(function() {
                        if (window.app && window.app.migrateBlazy) {
                            window.app.migrateBlazy();
                        }
                        
                        // Call component functions directly instead of using PubSub
                        if (window.app && window.app.bookBlockList && window.app.bookBlockList.run) {
                            window.app.bookBlockList.run();
                        }
                        if (window.app && window.app.bookBlockList && window.app.bookBlockList.initImageLoading) {
                            window.app.bookBlockList.initImageLoading();
                        }
                        if (window.app && window.app.featureBlockList && window.app.featureBlockList.run) {
                            window.app.featureBlockList.run();
                        }
                        if (window.app && window.app.featureBlockList && window.app.featureBlockList.initImageLoading) {
                            window.app.featureBlockList.initImageLoading();
                        }
                    }, 0);
                }
            })
            .fail(function() {
                $loadMore.removeClass('is-loading');
            })
            .always(function() {
                $loadMore.blur();
            });
    });
}

export default init;